import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { WorkbookDynamicChartsM } from '../models/workbook-dynamic-chart.models';

@Injectable({
    providedIn: 'root'
})
export class WorkspaceDynamicChartService {
    dynamicTableAPI: string;
    constructor(private http: HttpClient) {
        this.dynamicTableAPI = environment.dynamicTableAPI;
    }

    getDynamicCharts(worbookId: number): Observable<WorkbookDynamicChartsM[]> {
        return this.http.get<any>(`${this.dynamicTableAPI}DynamicChart?workbookId=${worbookId}`);
    }

    addDynamicCharts(worbookId: number, data: WorkbookDynamicChartsM): Observable<WorkbookDynamicChartsM> {
        return this.http.post<any>(`${this.dynamicTableAPI}DynamicChart?workbookId=${worbookId}`, data);
    }

    updateDynamicCharts(worbookId: number, data: WorkbookDynamicChartsM): Observable<WorkbookDynamicChartsM> {
        return this.http.put<any>(`${this.dynamicTableAPI}DynamicChart?workbookId=${worbookId}`, data);
    }

    deleteDynamicCharts(chartId: number): Observable<WorkbookDynamicChartsM> {
        return this.http.delete<any>(`${this.dynamicTableAPI}DynamicChart/${chartId}`);
    }

    saveFilterData(data: any): Observable<any> {
        return this.http.post(`${environment.dynamicTableAPI}DynamicChart/ChartFilterColumn`, data);
    }

    getSavedFilterData(chartId: number): Observable<any> {
        return this.http.get(`${environment.dynamicTableAPI}DynamicChart/${chartId}/ChartFilterColumn`);
    }
}
